exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{font-weight:300;overflow-wrap:break-word;word-wrap:break-word;hyphens:auto}\n", ""]);

// exports
